const Colors = {
    white: '#fff',
    black: '#000',
    yellow: '#ffdb00',
    lime: '#36c73d',
    green: '#009a49',
    turquoise: '#096b65',
    teal: '#09b3ae',
    cyan: '#1eb5da',
    blue: '#203276',
    purple: '#671f75',
    plum: '#ad1896',
    magenta: '#e30385',
    red: '#e12828',
    orange: '#ff7000',
    pink: '#fc5474',
    brown: '#644133',
    grey: '#808080',
    lightGrey: '#d1d1d2'
}

export default Colors;